import { isEmpty, map, omit } from "lodash";
import ScanAPI from "restAPI/ScanAPI";
import { ScanType } from "types/api/scanSummary";
import { getStartAndEndDateForQuickOption } from "utils/dateUtils";

export function isSBOMScan(record) {
  return (
    record?.scanType?.length === 1 &&
    record.scanType[0] === ScanType.SUPPLY_CHAIN
  );
}

export function getAllScan(params) {
  // eslint-disable-next-line no-unsafe-optional-chaining
  const { toolName, scanName, triggerby } = params?.props;
  const findingCounts = params?.filters?.findings;
  // Generate queryparams object
  const filters = params.filters;

  if (filters?.id && filters.id[0]) {
    const id = filters.id[0];
    if (isNaN(id)) {
      if (id.match(/s-/gi)) {
        filters.id[0] = id.split("-").pop();
      } else if (id === "s" || id === "S") {
        filters.id[0] = "";
      }
      if (filters.id[0] !== "" && isNaN(filters.id[0])) {
        filters.id[0] = -1;
      }
    }
  }
  if (filters?.createdAt && filters.createdAt.length === 1) {
    filters.createdAt = getStartAndEndDateForQuickOption({
      label: filters.createdAt[0],
      utcString: true,
    });
  }

  if (filters?.scanDate && filters.scanDate.length === 1) {
    filters.scanDate = getStartAndEndDateForQuickOption({
      label: filters.scanDate[0],
      utcString: true,
    });
  }

  if (filters?.tags) {
    filters.tags = map(filters.tags, (tag) => {
      const { key, value } = tag;
      let keyValue = key;
      if (value) {
        keyValue = `${key}:${value}`;
      }
      return keyValue;
    });
  }

  const obj = {
    ...params.filters,
    findingCounts,
    ...omit(params, ["filters", "sortColumn", "sortOrder"]),
  };

  if (filters?.mostRecentScans) {
    obj.mostRecentScans = filters.mostRecentScans;
  }

  if (!isEmpty(toolName)) obj["tool"] = scanName || toolName;
  if (!isEmpty(triggerby)) obj["triggerby"] = triggerby;

  delete obj.findings;
  return ScanAPI.getAll(obj);
}
